import { mapActions, mapGetters } from "vuex";
import aclAccess from "@/mixins/hasAccess";
import clientPermissions from "@/mixins/clientPermissions";

export default {
  mixins: [aclAccess, clientPermissions],
  data() {
    return {
      navMenuItems: [
        {
          url: "/Home",
          name: "الرئيسية",
          icon: "HomeIcon",
          i18n: "home",
        },
        {
          header: "الطلبات",
          icon: "PackageIcon",
          i18n: "orders",
          items: [
            {
              url: "/SavedOrder",
              name: "المحفوظة عند المتجر",
              slug: "order",
              i18n: "saveBeforeShip",
              icon: "CircleIcon",
            },
            // {
            //   url: "/PendingPickupOrders",
            //   name: "في انتظار الاستلام",
            //   slug: "Pending_Pickup_Orders",
            //   i18n: "statusPendingPickup",
            //   icon: "CircleIcon",
            // },
            // {
            //   url: "/PickedUpOrders",
            //   name: "تم الاستلام",
            //   slug: "Picked_Up_Orders",
            //   i18n: "statusPickedUp",
            //   icon: "CircleIcon",
            // },
            {
              url: "/SentOrder",
              name: "المرسلة من المتجر",
              slug: "order",
              i18n: "sentForShip",
              icon: "CircleIcon",
            },
            {
              url: "/UnderwayOrder",
              name: "في الشركة",
              slug: "order",
              i18n: "underWay",
              icon: "CircleIcon",
            },
            {
              url: "/ToBranch",
              name: "بالطريق الى الفرع",
              slug: "order",
              i18n: "toBranch",
              icon: "CircleIcon",
            },
            {
              url: "/WithBranch",
              name: "طلبات وصلت الفرع",
              slug: "order",
              i18n: "WithBranch",
              icon: "CircleIcon",
            },
            {
              url: "/PendingWithCaptain",
              name: "إلى المندوب",
              slug: "order",
              i18n: "pending",
              icon: "CircleIcon",
            },
            {
              url: "/WithCaptain",
              name: "withCaptain",
              slug: "order",
              i18n: "withCaptain",
              icon: "CircleIcon",
            },
            {
              url: "/DelayOrder",
              name: "المؤجلة مع المندوب",
              slug: "order",
              i18n: "delayed",
              icon: "CircleIcon",
            },
            {
              url: "/GivenOrder",
              name: "المسلمة",
              slug: "order",
              i18n: "given",
              icon: "CircleIcon",
            },
            {
              url: "/Supplied",
              name: "تمت التسوية",
              slug: "order",
              i18n: "supplied",
              icon: "CircleIcon",
            },
          ],
        },
        {
          url: "/Missions",
          name: "المهمات",
          icon: "ClipboardIcon",
          i18n: "missions",
        },
        {
          header: "التكاليف",
          icon: "DollarSignIcon",
          i18n: "costs",
          items: [
            {
              url: "/ClientCosts",
              name: "اسعار التوصيل",
              slug: "Costs",
              icon: "MapIcon",
              i18n: "client_costs",
            },
            {
              url: "/ClientOfficeCosts",
              name: "تكاليف توصيل تسليم مكتب",
              slug: "Costs",
              icon: "HomeIcon",
              i18n: "client_office_costs",
            }
          ]
        },
        {
          header: "المرتجعات",
          icon: "RewindIcon",
          i18n: "returns",
          items: [
            {
              url: "/ReturnWithCompany",
              name: "مرتجع مع الشركة",
              slug: "Return",
              icon: "MailIcon",
              i18n: "withCompany",
            },
            {
              url: "/ReturnWithCaptain",
              name: "مرتجع مع المندوب",
              slug: "ReturnWithCaptain",
              icon: "UserCheckIcon",
              i18n: "withCaptain",
            },
            {
              url: "/ReturnWithChangeBranch",
              name: "بالطريق للفرع",
              slug: "ReturnWithChangeBranch",
              icon: "CalendarIcon",
              i18n: "withChangeBranch",
            },
            {
              url: "/ReturnWithBranch",
              name: "مرتجعات مع الفرع",
              slug: "ReturnWithBranch",
              icon: "PackageIcon",
              i18n: "WithBranch",
            },
            // {
            //   url: "/returns/assigned-to-mission",
            //   name: "مرتجعات معينة لمهمة",
            //   slug: "ReturnedAssignedToMission",
            //   icon: "PackageIcon",
            //   i18n: "statusReturnedAssignedToMission",
            // },
            {
              url: "/Return",
              name: "المرتجعة",
              slug: "Return",
              icon: "PackageIcon",
              i18n: "returned",
            },
            {
              url: "/Resent",
              name: "معاد إرسالها",
              slug: "Return",
              icon: "CalendarIcon",
              i18n: "resend",
            },
          ],
        },
        {
          header: "طلبات تحتاج مراجعتك",
          icon: "CheckCircleIcon",
          i18n: "approvals",
          items: [
            {
              url: "/ReturnRequests",
              name: "طلبات المرتجعات",
              slug: "ReturnRequests",
              icon: "CheckSquareIcon",
              i18n: "",
            },
            {
              url: "/ChangePriceRequests",
              name: "طلبات تغيير السعر",
              slug: "ChangePriceRequests",
              icon: "DollarSignIcon",
              i18n: "",
            },
          ],
        },
        {
          header: "التقارير",
          icon: "FileTextIcon",
          i18n: "reports",
          items: [
            {
              url: "/reports/AllOrders",
              name: "كل الطلبات",
              slug: "report",
              icon: "PackageIcon",
              i18n: "allOrders",
            },
            {
              url: "/reports/Missions",
              name: "جميع المهمات",
              slug: "report",
              icon: "ClipboardIcon",
              i18n: "allMissions",
            }
          ],
        },
        {
          header: "إضافة طلب",
          icon: "PackageIcon",
          i18n: "",
          slug: "newOrder",
          items: [
            {
              url: "/addOrder",
              name: "إضافة طلب",
              slug: "chat",
              icon: "PackageIcon",
              i18n: "addOrder",
            },
            {
              url: "/AddOrderWithExcel",
              name: "إضافة طلبات بالإكسل",
              slug: "excel",
              icon: "FileIcon",
              i18n: "addExcel",
            },
          ],
        },
        {
          url: "/addMission",
          name: "مهمة جديدة",
          slug: "chat",
          icon: "CalendarIcon",
          i18n: "addMission",
        },
      ],
    };
  },
  computed: {
    ...mapGetters("userData", ["have_stock", "has_international_shipping"]),
  },
  methods: {
    ...mapActions("userData", ["fetchUserData"]),
    hasAccessCompany() {
      if (this.$acl.not.check("isPublicCompany")) {
        // return (
        //   (this.navMenuItems[1].items[4].name = "withCaptain"),
        //   (this.navMenuItems[1].items[4].i18n = "withCaptain")
        // );
      } else {
        return (
          (this.navMenuItems[1].items[4].name = "inProgress"),
          (this.navMenuItems[1].items[4].i18n = "inProgress")
        );
      }
    },
  },
  async mounted() {
    this.hasAccessCompany();
    await this.fetchUserData();
    // the price change requests page needs its own permission
    if (!this.can("price_change_requests")) {
      const approvals = this.navMenuItems.find((group) => group.i18n === "approvals");
      if (approvals) {
        approvals.items = approvals.items.filter((item) => item.slug !== "ChangePriceRequests");
      }
    }
    if (this.have_stock === 1) {
      this.navMenuItems.push({
        url: "/products",
        name: "المخزون",
        slug: "products",
        icon: "BriefcaseIcon",
        i18n: "myProducts",
      });
    }
    if (this.has_international_shipping) {
      this.navMenuItems.push({
        header: "الشحن الدولي",
        icon: "GlobeIcon",
        i18n: "internationalShipping",
        items: [
          {
            url: "/InternationalWallet",
            name: "حسابي الدولي",
            slug: "international",
            icon: "CircleIcon",
            i18n: "internationalWallet",
          },
          {
            url: "/InternationalShipments",
            name: "الشحنات الدولية",
            slug: "international",
            icon: "CircleIcon",
            i18n: "internationalShipments",
          },
        ],
      });
    }
  },
};
